import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import { getApi } from '../../api/endpoints.js';
import Page from "../Page.js";
import PageContentWrapper from "../../components/PageContentWrapper.js";
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants.js';
import Cluster from '../../models/Cluster.js';
import { toast } from 'react-toastify';
import FormPartial from './FormPartial.js';

const Edit = (props) => {
  const [cluster, setCluster] = useState((new Cluster()).toStateJson());
  let clusterObj = new Cluster(cluster);
  const [fetchApi] = getApi('showCluster');
  const [updateApi] = getApi('updateCluster');
  const navigate = useNavigate();
  const params = useParams();

  useEffect(() => {
    getRecord({ id: params.id })
  }, []);

  const getRecord = async (params) => {
    try {
      let response = await fetchApi({ id: params.id }).unwrap();
      setCluster((new Cluster(response.data.cluster)).toStateJson());
    } catch(error) {
      toast.error(error?.data?.message || "Something Went Wrong !");
    }
  }

  const updateRecord = async (params) => {
    try {
      await updateApi(params).unwrap();
      navigate("/clusters");
      toast.success("Updated Successfully");
    } catch(error) {
      clusterObj.set_api_errors(error.data.data.errors);
      toast.error(error?.data?.message || "Something Went Wrong !");
    }
  }

  const onUpdateClick = () => {
    try{
      updateRecord((new Cluster(cluster)).toApiJson());
    } catch(error){
      setCluster(new Cluster(cluster));
    }
  }

  const onBackClick = () => {
    navigate("/clusters");
  }

  return <Page
    uiPage={uiManager.getUiPage(PAGES.EditClusterPage.name)}
    breadcrumbs={[{ label: "Home", url: '/dashboard' }, { label: "Cluster", url: '/clusters' }, { label: "Edit" }]}
    className={'cluster-edit-page'}
  >
    <PageContentWrapper contentHeading={"Edit Cluster"}>
      <div className='m-3'>
        <form className="row g-4" autoComplete="off">
          <FormPartial cluster={cluster} setCluster={setCluster}/>
          <div className='mb-4 col-md-12'>
            <div>
              <button type="button" className="btn btn-voltup-theme" onClick={onBackClick} style={{ float: 'inline-start' }}>
                Back
              </button>
              <button type="button" className="btn btn-voltup-theme ms-3" onClick={onUpdateClick}>
                Update Cluster
              </button>
            </div>
          </div>
        </form>
      </div>
    </PageContentWrapper>
  </Page>
};

export default Edit;
